import getConfig from "next/config";
import { logger } from "./helper/logger";

const { serverRuntimeConfig } = getConfig();

type FetchSCProps = {
  query: string;
  variables: Record<string, any>;
};

type FetchSCResult<T> = {
  data: T;
  errors?: { message: string }[];
};

export async function fetchSC<T>({
  query,
  variables,
}: FetchSCProps): Promise<FetchSCResult<T>> {
  try {
    const response = await fetch(process.env.GRAPHQL_URI as string, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept-language": serverRuntimeConfig.LOCALE,
        "Accept-StoreKey": serverRuntimeConfig.STORE_KEY,
        "Request-Source": "WEB_SHOP_APP",
      },
      body: JSON.stringify({
        query,
        variables,
      }),
    });

    return (await response.json()) as FetchSCResult<T>;
  } catch (error) {
    logger({
      message: "Error fetching from Service Connector",
      error: error as Error,
    });

    return { data: {} as T, errors: [{ message: (error as Error).message }] };
  }
}
